import ViewStorageList from "../components/tabledataviews/storage-list/ViewStorageItemList"
import ViewSettings from "../components/ViewSettings"
import ViewTemplatesList from "../components/manufacturing/ViewTemplatesList"
import TemplateForm from "../components/manufacturing/TemplateForm"
import ViewOrdersList from "../components/manufacturing/ViewOrdersList"
import OrderForm from "../components/manufacturing/OrderForm"
import ViewUserContactList from "../components/tabledataviews/contacts-list/ViewUserContactList"
import ViewCyclesList from "../components/manufacturing/ViewCyclesList"
import CycleForm from "../components/manufacturing/CycleForm"
import ViewCycleDetail from "../components/manufacturing/ViewCycleDetail"


export const modules = {
  StorageItemList: "STORAGE_ITEM_LIST",
  Settings: "SETTINGS",
  TemplatesList: "TEMPLATES_LIST",
  CreateTemplate: "CREATE_TEMPLATE",
  EditTemplate: "EDIT_TEMPLATE",
  OrdersList: "ORDERS_LIST",
  CreateOrder: "CREATE_ORDER",
  EditOrder: "EDIT_ORDER",
  CyclesList: "CYCLES_LIST",
  CreateCycle: "CREATE_CYCLE",
  EditCycle: "EDIT_CYCLE",
  ViewCycle: "VIEW_CYCLE",
  ContactList: "CONTACT_LIST",
} as const

export const contentPath = {
  [modules.StorageItemList]: "/storage-item-list",
  [modules.Settings]: "/settings",
  [modules.TemplatesList]: "/templates",
  [modules.CreateTemplate]: "/create-template",
  [modules.EditTemplate]: "/edit-template/:uid",
  [modules.OrdersList]: "/orders",
  [modules.CreateOrder]: "/create-order",
  [modules.EditOrder]: "/edit-order/:uid",
  [modules.CyclesList]: "/cycles",
  [modules.CreateCycle]: "/create-cycle",
  [modules.EditCycle]: "/edit-cycle/:uid",
  [modules.ViewCycle]: "/view-cycle/:uid",
  [modules.ContactList]: "/contact-list",
} as const

export const contentLayout = {
  [modules.StorageItemList]: ViewStorageList,
  [modules.Settings]: ViewSettings,
  [modules.TemplatesList]: ViewTemplatesList,
  [modules.CreateTemplate]: TemplateForm,
  [modules.EditTemplate]: TemplateForm,
  [modules.OrdersList]: ViewOrdersList,
  [modules.CreateOrder]: OrderForm,
  [modules.EditOrder]: OrderForm,
  [modules.CyclesList]: ViewCyclesList,
  [modules.CreateCycle]: CycleForm,
  [modules.EditCycle]: CycleForm,
  [modules.ViewCycle]: ViewCycleDetail,
  [modules.ContactList]: ViewUserContactList,
} as const
